module.exports = {"id":"227236","name":"André Franck Zambo Anguissa","rating":"75","photo":"./data/images/photos/0/227236.png","club":{"name":"OM","logo":"./data/images/clubs/OM.png"},"positions":["MDC","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndreFranckZamboAnguissa0.json
// module id = 337
// module chunks = 0